import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next"; 
import config from "../config";
import {handleMenuActive} from "../assets/js/swithalert"


const Breadcrumb = () => {
  const location = useLocation();
  const { t } = useTranslation(); 

  const pathnames = location.pathname.split("/").filter((x) => x);

  // Define the translation keys for each route
  const breadcrumbNames = {
    "/": t("home_title"),
    "/self-wash": t("nav_selfwash"),
    "/self-dry": t("nav_selfdry"),
    "/contact": t("nav_contact"),
    "/pricing": t("nav_pricing"),
  };

  const currentPath = `/${pathnames[pathnames.length - 1]}`;
  const pageTitle = breadcrumbNames[currentPath] || t("home_title");
  const metaDescription = t("meta_description")

  useEffect(() => {
    document.title = `${pageTitle} | ${config.brand} `;
    handleMenuActive();
    const metaDescriptionTag = document.querySelector("meta[name='description']");
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute("content", metaDescription);
    }
  }, [pageTitle, metaDescription]);

  
  // Hide breadcrumb on the home page
  if (pathnames.length === 0) return null;


  return (
    <nav className="pl_breadcrumb">
      <Link to="/">{t("nav_home")}</Link>
      {pathnames.map((_, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const name = breadcrumbNames[routeTo]

        return isLast ? (
          <span key={routeTo}> {name} | {config.brand}</span>
        ) : (
          <span key={routeTo}>
            {" "}
            / <Link to={routeTo}>{name}</Link>
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
